export { default } from './ClassPassEdit';

